// @flow
export const SELECT_AUTO_RENEW_ITEMS = 'checkout/payment/SELECT_AUTO_RENEW_ITEMS';

export const selectAutoRenewItems = (selected: boolean, ids: number[]) => ({
  type: SELECT_AUTO_RENEW_ITEMS,
  ids,
  selected,
});
